import { Icon, InputText, TextArea } from "@bluframe/blublocks"
import Button from "components/buttons/Button"

import { ComponentProps } from "."
import { RegenerateIcon, TextAreaAndButton } from "./styled"

interface Props {
  readonly image: ComponentProps["image"]
  readonly isAlternativeTextRegenerating: boolean
  readonly isCaptionRegenerating: boolean
  readonly onAlternativeTextInputChange: ComponentProps["onAlternativeTextInputChange"]
  readonly onCaptionInputChange: ComponentProps["onCaptionInputChange"]
  readonly onCreditInputChange: ComponentProps["onCreditInputChange"]
  readonly onInputTextClick: ComponentProps["onInputTextClick"]
  readonly onRegenerateAlternativeTextClick?: ComponentProps["onRegenerateAlternativeTextClick"]
  readonly onRegenerateCaptionClick?: ComponentProps["onRegenerateCaptionClick"]
  readonly showScreenshotMetadataInputs?: ComponentProps["showScreenshotMetadataInputs"]
}

const MetadataFields = ({
  image,
  isAlternativeTextRegenerating,
  isCaptionRegenerating,
  onAlternativeTextInputChange,
  onCaptionInputChange,
  onCreditInputChange,
  onInputTextClick,
  onRegenerateAlternativeTextClick,
  onRegenerateCaptionClick,
  showScreenshotMetadataInputs
}: Props) => (
  <>
    <InputText
      inputId={`${image.identifier}-credit`}
      label="Credit"
      name={`imageCredit-${image.identifier}`}
      onChange={onCreditInputChange}
      onClick={onInputTextClick}
      type="text"
      value={image.credit ?? ""}
    />

    {showScreenshotMetadataInputs ? (
      <>
        <TextAreaAndButton onClick={onInputTextClick}>
          <TextArea
            disabled={isAlternativeTextRegenerating}
            inputId={`${image.identifier}-alternativeText`}
            label="Alternative text"
            name={`imageAlternativeText-${image.identifier}`}
            onChange={onAlternativeTextInputChange}
            rows={3}
            value={image.alternativeText ?? ""}
          />

          {onRegenerateAlternativeTextClick ? (
            <Button
              disabled={isAlternativeTextRegenerating || !image.originalUrl}
              icon={
                <RegenerateIcon $isSpinning={isAlternativeTextRegenerating}>
                  <Icon group="fa6" name="FaRotateLeft" />
                </RegenerateIcon>
              }
              iconOnly
              label="Regenerate Alternative Text"
              onClick={onRegenerateAlternativeTextClick}
              outlined
              transparent
            />
          ) : null}
        </TextAreaAndButton>

        <TextAreaAndButton onClick={onInputTextClick}>
          <TextArea
            disabled={isCaptionRegenerating}
            inputId={`${image.identifier}-caption`}
            label="Caption"
            name={`imageCaption-${image.identifier}`}
            onChange={onCaptionInputChange}
            rows={3}
            value={image.caption ?? ""}
          />

          {onRegenerateCaptionClick ? (
            <Button
              disabled={isCaptionRegenerating || !image.originalUrl}
              icon={
                <RegenerateIcon $isSpinning={isCaptionRegenerating}>
                  <Icon group="fa6" name="FaRotateLeft" />
                </RegenerateIcon>
              }
              iconOnly
              label="Regenerate Caption"
              onClick={onRegenerateCaptionClick}
              outlined
              transparent
            />
          ) : null}
        </TextAreaAndButton>
      </>
    ) : null}
  </>
)

export default MetadataFields
